/** Translucent frosted-glass pill button for world detail action bars. */
export const BTN_GLASS_PILL =
  'text-vive-primary-20 h-9 min-w-max shrink-0 rounded-full bg-white/10 px-4 py-2 backdrop-blur-3xl hover:bg-white/20 hover:text-white active:bg-white/15' as const
